<div class="size-10 lg:h-12 lg:w-12 btn small">
  <div
    [ngClass]="appearance() === 'dark' ? 'bg-platform' : 'bg-white'"
    class="flex items-center place-content-center rounded-full h-full"
  >
    <div
      [ngClass]="appearance() === 'dark' ? 'text-white' : 'text-platform'"
      class="text-sm lg:text-base tracking-wider"
    >
      {{ userInitials() }}
    </div>
  </div>
</div>
